import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../lib/firebase';
import { getStoredUserProfile, persistUserSession } from '../utils/authStorage';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(() => getStoredUserProfile());

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      const normalizedUser = persistUserSession(firebaseUser);
      setUser(normalizedUser);
      setIsAuthenticated(Boolean(normalizedUser));
      setLoading(false);
    }, (error) => {
      console.error('Firebase auth state sync failed', error);
      setUser(null);
      setIsAuthenticated(false);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return { isAuthenticated, user, loading };
}
